/**************************************************
 * Nombre:       Tarjeta_Documentos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import ic_documentos from '../../Recursos/Iconos/ic_documentos.svg'
import {theme} from "../../Tema";
import {NEGRITA} from "../../Constantes";
import {East} from '@mui/icons-material'
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {irUrl} from "../../Utilidades/irUrl";


const Tarjeta_Documentos = ({item}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            onClick={() => item.url ? irUrl(item.url) : ''}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#fff',
                py: 2,
                px: 2,
                boxShadow: 2,
                overflow: 'hidden',
                cursor: item.url ? 'pointer' : 'standar',
                height: 180,
            }}
        >

            <Grid container size={{xs: 1, sm: 2, md: 1}} sx={{justifyContent: 'flex-start'}}>
                <img src={ic_documentos} width={sCell ? 52 : 60} height={'auto'} alt={item.nombre}/>
            </Grid>

            <Grid container size={{xs: 9, sm: 9, md: 10}} sx={{justifyContent: 'flex-start', pl: 3, mt: 1}}>
                <Typography sx={{
                    color: theme.palette.primary.main,
                    fontFamily: NEGRITA,
                    fontSize: sCell ? 16 : 20,
                    lineHeight: 1.2,
                    height: 100
                }}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-end', mr: -10, mb: -4, ml: 3, mt: -1}}>
                <IconButton sx={{
                    backgroundColor: theme.palette.secondary.main,
                    width: sCell ? 72 : 80,
                    height: sCell ? 72 : 80
                }}>
                    <East sx={{fill: '#fff'}}/>
                </IconButton>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Documentos    